import { createSelector } from 'reselect'

const CHECKOUT_LOYALTY_ESIM_ALLOWED_MODES = new Set<App.CheckoutCartMode | undefined>([
  undefined, // Standard checkout before cart mode is set
  'default',
  'vertical-select',
  'esim-upgrade',
  'flight-change-dates',
])

/** Checkout mode boundary for loyalty eSIM UI. */
const getIsCheckoutModeEligibleForLoyaltyEsim = createSelector(
  (state: App.State) => state.checkout.cart.mode,
  (mode): boolean => CHECKOUT_LOYALTY_ESIM_ALLOWED_MODES.has(mode),
)

export default getIsCheckoutModeEligibleForLoyaltyEsim
